import React from 'react';
import { path, pathOr } from 'ramda';
import PropTypes from 'prop-types';

import { REPORT_STATUSES } from 'store/reports';

import { Container, Item } from './styles';

const Row = ({ id, widths, publicId, patientName, receiverName, date, status }) => (
  <Container key={publicId} to={`/reports/${id}`}>
    <Item width={widths[0]}>{publicId}</Item>
    <Item width={widths[1]}>{patientName}</Item>
    <Item width={widths[2]}>{receiverName}</Item>
    <Item width={widths[3]}>{date}</Item>
    <Item width={widths[4]} $color={path([status, 'color'], REPORT_STATUSES)} $fontSize={10}>
      {pathOr('-', [status, 'title'], REPORT_STATUSES)}
    </Item>
  </Container>
);

Row.defaultProps = {
  publicId: '',
  patientName: '',
  receiverName: '',
  date: '',
};

Row.propTypes = {
  id: PropTypes.string.isRequired,
  widths: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  publicId: PropTypes.string,
  patientName: PropTypes.string,
  receiverName: PropTypes.string,
  date: PropTypes.string,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Row;
